var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"excel-btn",attrs:{"small":"","text":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},on),[_c('img',{attrs:{"src":_vm.excelIcon}})])]}}])},[_c('span',[_vm._v("Download Excel")])])
}
var staticRenderFns = []

export { render, staticRenderFns }